if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      fetchAvailability(variantId) {
        let rootUrl = this.getAttribute('data-root-url');
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        }
        else {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
        }
      }

      replaceLocationName(text, locationName) {
        if (!text) return '';
        return text
          .replace(/\[location_name\]/g, locationName)
          .replace(/\{\{\s*location_name\s*\}\}/g, locationName);
      }

      applyCustomText(preview) {
        if (!preview) return;

        const locationName = preview.dataset.locationName;
        if (!locationName) return;

        const availableMessage = preview.querySelector('[data-pickup-message="available"]');
        if (availableMessage && this.dataset.textAvailableAt) {
          availableMessage.textContent = this.replaceLocationName(this.dataset.textAvailableAt, locationName);
        }

        const unavailableMessage = preview.querySelector('[data-pickup-message="unavailable"]');
        if (unavailableMessage && this.dataset.textUnavailableAt) {
          unavailableMessage.textContent = this.replaceLocationName(this.dataset.textUnavailableAt, locationName);
        }

        preview.querySelectorAll('[data-pickup-link]').forEach((link) => {
          if (link.dataset.pickupLink === 'view_store' && this.dataset.textViewStore) {
            link.textContent = this.dataset.textViewStore;
          }

          if (link.dataset.pickupLink === 'check_stores' && this.dataset.textCheckOtherStores) {
            link.textContent = this.dataset.textCheckOtherStores;
          }
        });
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('.pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('.pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
          return;
        }

        const preview = sectionInnerHTML.querySelector('.pickup-availability-preview');
        this.applyCustomText(preview);
        this.innerHTML = preview.outerHTML;
        this.removeAttribute('hidden');
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('.pickup-availability-drawer'));
      }
    }
  );
}
